import React, {lazy, Suspense} from 'react';
import {Switch, Route, BrowserRouter as Router, Redirect} from 'react-router-dom';

import Header from 'components/Header';
import Footer from 'components/Footer';
import UsefulLinks from './pages/components/UsefulLinks';
import Spinner from 'components/Spinner';

const Home = lazy(() => import('./pages/Home'));
const About = lazy(() => import('./pages/About'));
const News = lazy(() => import('./pages/News'));
const NewsView = lazy(() => import('./pages/News/View'));
const Images = lazy(() => import('./pages/Gallery/Images'));
const Videos = lazy(() => import('./pages/Gallery/Videos'));
const Decisions = lazy(() => import('./pages/Decisions'));
const DecisionView = lazy(() => import('./pages/Decisions/View'));
const Staff = lazy(() => import('./pages/Staff'));
const Vacancy = lazy(() => import('./pages/Vacancy'));
const Page = lazy(() => import('./pages/Page'));
const FileUploadForm = lazy(() => import('./pages/Upload/Upload'));

// publicRoutes
const publicRoutes = [
  {path: '/', exact: true, component: Home},
  {path: '/news', exact: true, component: News},
  {path: '/news/:slug', exact: true, component: NewsView},
  {path: '/gallery/images', exact: true, component: Images},
  {path: '/gallery/videos', exact: true, component: Videos},
  {path: '/about', exact: true, component: About},
  {path: '/decisions', exact: true, component: Decisions},
  {path: '/decisions/:slug', exact: true, component: DecisionView},
  {path: '/staff', exact: true, component: Staff},
  {path: '/vacancy', exact: true, component: Vacancy},
  {path: '/page/:slug', exact: true, component: Page},
  { path: '/upload', exact: true, component: FileUploadForm },
];

const Routes = () => {
  
  return (
    <Router>
      <Header/>
      <Suspense fallback={<Spinner/>}>
        <>
          <Switch>
            {
              publicRoutes.map((route, key) => (
                <Route
                  key={key}
                  path={route.path}
                  exact={route.exact}
                  component={route.component}
                />
              ))
            }
            <Redirect from="*" to="/"/>
          </Switch>
        </>
      </Suspense>
      <div className={"flex-fill"}/>
      <UsefulLinks />
      <Footer/>
    </Router>
  )
};

export default Routes;